export const listStyles = {
  display: 'flex',
  flexDirection: 'column',
  border: ({ palette }) => `1px solid ${palette.border.default}`,
  borderRadius: '8px',
};
